


















































import { mapGetters } from 'vuex';

export default {
    name: 'JobIndustries',

    props: {
        canModifyJob: {
            default: false,
            required: false,
            type: Boolean,
        },

        completed: {
            default: null,
            required: false,
            type: [Boolean, null],
        },
    },

    computed: {
        ...mapGetters('jobs/single', {
            job: 'getSingleJob',
        }),

        industries() {
            return this.job.industries.length > 0 ? this.job.industries.map((item) => item.industry_name) : null;
        },

        fieldsOfInterest() {
            return this.job.industries.length > 0
                ? this.job.industries
                      .map((item) => item.fields_of_interest)
                      .map((item) => item.map((item) => item.name))
                      .reduce((prev, curr) => [...new Set([...prev, ...curr])])
                : [];
        },
    },

    methods: {
        edit() {
            this.$emit('open-draft', 2, '#job-sector');
        },
    },
};
